module.exports = __webpack_public_path__ + "75e8975966c040d18b299029193d3b1f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Abel.ttf
// module id = 104
// module chunks = 0